import { useSetAtom } from "jotai";

import { $createPage } from "../../internal/page";

export const useCreatePage = () => {
	const createPage = useSetAtom($createPage);

	return createPage;
};
